module.exports = __webpack_public_path__ + "static/media/texture-red.a1a23a3a.png";